import * as React from "react";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

import { TaskPaneProvider } from "../provider/TaskPaneProvider";
import MainContent from "./mainContent";

import { reactPlugin } from '../../telemetry/telemetryService';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';

const App = () => {

  React.useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const mode = urlParams.get('dialog');
      sessionStorage.setItem('actionType', mode === "compose"? "sendMailAndOpenTaskPane": "openDialog");
  }, []);
  
  return (
    <AppInsightsErrorBoundary onError={() => console.log("Error captured")} appInsights={reactPlugin}>
    <FluentProvider theme={webLightTheme}>
      <TaskPaneProvider>
        <MainContent />
      </TaskPaneProvider>
    </FluentProvider>
    </AppInsightsErrorBoundary>
  );
};

export default App;
